import tinyMCEConfigFor from "./tiny_mce_configs";

export default {
	init: (selector, extraInitInstanceCallback = undefined) => {
		$(selector).each((idx, mceTarget) => {
			// pp.log("TINYMCE init", mceTarget.id, tinyMCE.editors[mceTarget.id], $(mceTarget));
			let initTimeout = 0;
			const presentEditor = tinyMCE.editors[mceTarget.id];
			// @ts-expect-error
			if (presentEditor !== undefined && presentEditor.markedForDestruction) {
				pp.log("- deleting lingering editor for target", mceTarget.id);
				initTimeout = 100; // Give tinyMCE some time to dstroy the editor instance before initializing one for the same target id
				presentEditor.destroy();
			}
			setTimeout(function () {
				pp.tinyMCE.initIndividualEditor(mceTarget, extraInitInstanceCallback);
			}, initTimeout);
		});
	},

	initIndividualEditor: (mceTarget, extraInitInstanceCallback) => {
		// Mark the target as initialized so that the selector from _rtf_info_fields.html.erb will not target it again
		$(mceTarget).addClass("j-initialized-mce");

		const mceConfig = Object.assign({}, tinyMCEConfigFor(mceTarget), {
			target: mceTarget,
			setup: pp.tinyMCE.setupFunction,
			directionality: I18n.t("meta.direction") == "rtl" ? "rtl" : "ltr", // Is not defined for non-rtl languages
			init_instance_callback: (editor) => {
				// Just a wrapper
				pp.tinyMCE.initInstanceCallback(editor, extraInitInstanceCallback);
			},
		});

		tinyMCE.init(mceConfig);
	},

	setupFunction: (editor) => {
		// Destroy the editor instance when the editor's target is destroyed
		const $mceTarget = $(`#${editor.id}`);
		pp.log("TINYMCE into setup -- editor, target", editor, $mceTarget);
		// @ts-expect-error
		editor.diffMP = new diff_match_patch();
		$mceTarget.one("destroyed destroyed_proxy", () => {
			// pp.log("TINYMCE destroying editor of target", $mceTarget);
			editor.destroy();
		});
		// Disable the editor before the page changes, then actually destroy the instance once the page change has occurred
		$(document).one("page:before-change", () => {
			// Test this in case the target element has been removed in the meantime
			// This only happens for the answer text areas of text Tasks that were completed before a Phase change
			if (editor.targetElm !== null) {
				editor.setMode("readonly");
			}
			editor.markedForDestruction = true;
			$(document).one("page:change", () => {
				editor.destroy();
			});
		});

		setTimeout(() => {
			if ($mceTarget.prop("disabled") == true) {
				pp.log("TINYMCE setting readonly", $mceTarget);
				editor.setMode("readonly");
			}
		}, 300);

		let targetPad;
		// pp.log("TINYMCE slave pad? / self pad?", $mceTarget.data('padSlaveFor'), $mceTarget.data('pad'));
		if ($mceTarget.data("padSlaveFor") !== undefined) {
			targetPad = $mceTarget.data("padSlaveFor").data("pad");
		} else {
			targetPad = $mceTarget.data("pad");
		}

		if (!targetPad) {
			// pp.log(`TINYMCE: No pad or pad disabled for ${mceTarget.id}`);
			return;
		}

		// pp.log("TINYMCE: pad for:", $mceTarget, targetPad);
		targetPad.targets.forEach((target, index) => {
			pp.log(
				"TINYMCE target vs mceTarget",
				target.elem,
				$mceTarget,
				!target.elem.is($mceTarget),
			);

			if (!target.elem.is($mceTarget)) {
				pp.log(
					"TINYMCE Skipping PadIntegration -- mceTarget, padTarget:",
					$mceTarget,
					target.elem,
				);
				return;
			}

			pp.tinyMCE.initPadIntegration(editor, targetPad, index);
		});
	},

	initInstanceCallback: (editor, extraInitInstanceCallback) => {
		// pp.log("TINYMCE into initInstanceCallback -- editor, target elem", editor, editor.targetElm, extraInitInstanceCallback);
		// Switch the word counter to the character counter mode
		$(editor.getContainer())
			.find("button.tox-statusbar__wordcount")
			.trigger("click");

		if (editor.targetElm.maxLength != 0) {
			pp.tinyMCE.initCharsUtilIntegration(editor);
		}
		if (extraInitInstanceCallback !== undefined) {
			extraInitInstanceCallback(editor);
		}
	},

	initPadIntegration: (editor, pad, targetIndex) => {
		// pp.log("TINYMCE into initPadIntegration", editor, pad, targetIndex);
		let notifyNodeChangeTimeout;
		let editorFullyInitialized = false;
		let fayeSubscriptionCompleted = false;

		editor.isFocused = false;
		editor.on("change keyup", (event) => {
			// pp.log("change", event);
			if (
				event.type == "change" &&
				(event.level.content.indexOf(";base64") != -1 ||
					event.level.content.indexOf("blob:http") != -1)
			) {
				pp.log(
					"base64 or blob",
					event.level.content.indexOf(";base64"),
					event.level.content.indexOf("blob:http"),
				);
				return;
			}
			// Catch the case where an image has just been pasted into the editor and is not uploaded to Rails yet
			editor.save(); // Save the content to the textarea so that the Pad sees it
			pp.tinyMCE.normalizeAndSaveContent(editor);
			$(pad.targets[targetIndex].elem).trigger("input"); // Notify the pad
		});

		editor.on("NodeChange", (event) => {
			// Use the `NodeChange` event as a proxy for the editor being fully initialized
			// (`AddEditor` does not actually indicate this)
			if (!editorFullyInitialized) {
				pp.tinyMCE.normalizeAndSaveContent(editor);
				editorFullyInitialized = true;
			}
			// Only pipe node changes through to other users' pads if the editor has actually been focused by the user.
			// 'NodeChange' does not actually mean that this editor's user selected anything yet.
			if (!editor.isFocused) {
				return;
			}
			const editorTargetData = $(editor.targetElm).data();
			let targetPad;
			// Always use the pad from the target's data attribute, not the one from the params.
			// It might have been removed in the meantim (from `clearData`), in which case we don't want to call `notifyTinyMCENodeChange` anymore
			if (Object.keys(editorTargetData).includes("padSlaveFor")) {
				targetPad = $(editorTargetData.padSlaveFor).data("pad");
			} else {
				targetPad = editorTargetData.pad;
			}
			if (
				notifyNodeChangeTimeout ||
				!fayeSubscriptionCompleted ||
				targetPad === undefined
			) {
				return;
			}
			notifyNodeChangeTimeout = setTimeout(() => {
				targetPad.notifyTinyMCENodeChange(targetIndex);
				notifyNodeChangeTimeout = null;
			}, 100);
		});

		editor.on("focusin", () => {
			editor.isFocused = true;
		});

		editor.on("focusout", (event) => {
			editor.isFocused = false;
			$(pad.targets[targetIndex].elem).trigger("focusout"); // Notify the pad
		});
		pad.targets[targetIndex].updateCursorPositionHandler = () => {}; // We don't need it for this target

		pad.targets[targetIndex].setCursorPositionHandler =
			pp.tinyMCE.getSelectionRange;

		pad.observeChange("activeSubscribers", (oldval, newval) => {
			pp.tinyMCE.updateActiveSubscribersCarets(editor, newval[targetIndex]);
		});
		pad.observeChange("inputFieldsState", (oldval, newval) => {
			editor.setMode(newval.enabled ? "design" : "readonly");
		});
		pad.targets[targetIndex].setValueCallbacks.push((string) => {
			pp.tinyMCE.overwriteContentAndResetSelection(
				pad,
				targetIndex,
				editor,
				string,
			);
		});
		// NB `pad` and  `currentVectors` is unused here
		pad.fayeSubscriptionCallbacks.push((pad, currentVectors) => {
			fayeSubscriptionCompleted = true;
		});
	},

	getNormalizedContent: (editor) => {
		// `parseFromString` will turn a `<p>&nbsp;</p>` into a ` \n` (= a space with a line break)
		// even though it's jsut meant as a simple line break, so cut the `&nbsp;`.
		const sanitizedHtmlContent = editor
			.getContent()
			.replaceAll("<p>&nbsp;</p>", "<p></p>");
		return new DOMParser().parseFromString(sanitizedHtmlContent, "text/html")
			.body.textContent;
	},

	normalizeAndSaveContent: (editor) => {
		editor.normalizedContent = pp.tinyMCE.getNormalizedContent(editor);
	},

	overwriteContentAndResetSelection: (pad, targetIndex, editor, string) => {
		pp.log(
			"into overwriteContentAndResetSelection",
			pad.currentSelectionRange,
			editor.normalizedContent,
		);
		pp.log("in overwriteContentAndResetSelection", string);
		const oldNormalizedContent = editor.normalizedContent;
		editor.setContent(string, {
			format: "html",
		});

		// There will not be `oldNormalizedContent` when the editor is not fully initialized yet,
		// but `overwriteContentAndResetSelection` will be called before when the initially loaded content is out of date (i.e. via the Pad's `overwriteOtherPad`)
		if (oldNormalizedContent !== undefined) {
			const oldSelectionRange = pad.currentSelectionRange;

			const newNormlizedContent = pp.tinyMCE.getNormalizedContent(editor);
			const diffArr = editor.diffMP.diff_main(
				oldNormalizedContent,
				newNormlizedContent,
			);
			pp.log("diff", diffArr);
			if (oldSelectionRange !== undefined) {
				const updatedSelectionRange = pp.tinyMCE.updateCursorPosition(
					oldSelectionRange,
					diffArr,
				);
				if (updatedSelectionRange !== undefined) {
					pad.currentSelectionRange = updatedSelectionRange;
				} else {
					// `updateCursorPosition` will return `undefined` if the text that was selected does not exist anymore
					pad.currentSelectionRange = { start: 0, end: 0 };
				}
			}
		}
		pp.tinyMCE.normalizeAndSaveContent(editor);
		if (pad.currentSelectionRange !== undefined) {
			// pp.log("UPDATED", pad.currentSelectionRange);
			pp.tinyMCE.setSelectionRange(
				editor,
				pad.currentSelectionRange.start,
				pad.currentSelectionRange.end,
			);
		}
		pp.tinyMCE.updateActiveSubscribersCarets(
			editor,
			pad.activeSubscribers[targetIndex],
		);
	},

	updateActiveSubscribersCarets: (editor, newActiveSubscribersPerActor) => {
		// pp.log("into updateActiveSubscribersCarets -- editor, newActiveSubscribersPerActor", editor, newActiveSubscribersPerActor);
		// Remove all previous selection highlighters
		if (editor.getBody()) {
			// not be present when content is being overwritten at Pad load
			$(editor.getBody().parentElement).children(".j-user-selection").remove();
		}

		Object.keys(newActiveSubscribersPerActor).forEach((actorId, index) => {
			const selectionData = newActiveSubscribersPerActor[actorId];

			const paintingFunctionWrapper = (editor, editorRect, rectIndex) => {
				pp.tinyMCE.highlightUserSelection(
					editor,
					editorRect,
					rectIndex,
					actorId,
					selectionData.selectionColor,
				);
			};
			pp.tinyMCE.highlightEditorText(
				editor,
				selectionData.selectionStart,
				selectionData.selectionEnd,
				paintingFunctionWrapper,
			);
		});
	},

	updateCursorPosition: (currentSelectionRange, diffArr) => {
		let offset = 0;

		$(diffArr).each(function () {
			const changeType = this[0];
			const changeText = this[1].replace("\\n", "\n"); // `diff_main´ escapes line breaks, so unescape them again

			switch (changeType) {
				case 0: // no changes
					offset += changeText.length;
					break;

				case 1: // insertion
					if (offset <= currentSelectionRange.start) {
						currentSelectionRange.start += changeText.length;
						currentSelectionRange.end += changeText.length;
					} else if (
						currentSelectionRange.start <= offset &&
						offset < currentSelectionRange.end
					) {
						currentSelectionRange = undefined;
					}
					offset += changeText.length;
					break;

				case -1: // deletion
					if (
						offset < currentSelectionRange.start &&
						offset + changeText.length <= currentSelectionRange.start
					) {
						currentSelectionRange.start -= changeText.length;
						currentSelectionRange.end -= changeText.length;
					} else if (
						(currentSelectionRange.start <= offset &&
							offset < currentSelectionRange.end) ||
						(offset <= currentSelectionRange.start &&
							currentSelectionRange.start < offset + changeText.length) ||
						(offset <= currentSelectionRange.start &&
							currentSelectionRange.end <= offset + changeText.length)
					) {
						currentSelectionRange = undefined;
					}
					// NO adding to `offset` here
					break;
			}
		});
		// pp.log("new", currentSelectionRange);
		return currentSelectionRange;
	},

	getSelectionRange: (inputElem, pad) => {
		const editor = tinyMCE.editors[inputElem.id];
		// @ts-expect-error
		if (!editor.isFocused && pad.currentSelectionRange === undefined) {
			// pp.log("not focused and no currentSelectionRange");
			return undefined;
		}
		// @ts-expect-error
		const currentRange = editor.selection.getRng().cloneRange();

		pp.log("getSelectionRange", currentRange);
		if (
			currentRange.startContainer.nodeType != 3 &&
			currentRange.startContainer.childNodes.length
		) {
			// pp.log("getSelectionRange overwriting start", currentRange.startContainer);
			if ($(currentRange.startContainer).hasClass("mce-content-body")) {
				pp.log("getSelectionRange is set to body");
				return { start: 0, end: 0 };
			}
			currentRange.setStart(
				currentRange.startContainer.firstChild || currentRange.startContainer,
				0,
			); // Set to the beginning of the first child
		}
		if (currentRange.endContainer.nodeType != 3) {
			const firstNodeTextContent = pp.tinyMCE.sanitizeTextContent(
				currentRange.startContainer.textContent,
			);
			const firstNodeTextContentLength =
				firstNodeTextContent.length -
				pp.tinyMCE.countHighSurrogates(firstNodeTextContent);
			// pp.log("overwriting end", currentRange.startContainer, firstNodeTextContentLength);
			currentRange.setEnd(
				currentRange.startContainer.firstChild || currentRange.startContainer,
				firstNodeTextContentLength,
			); // Set to the end of the first child
		}

		// @ts-expect-error
		let normalizedContent = editor.normalizedContent;
		// pp.log("normalized content", normalizedContent);

		let offsetTillNow = 0;
		let offsetTillRangeStart;
		let offsetTillRangeEnd;
		// @ts-expect-error
		let currentNode = editor.getBody().firstChild;
		let currentNestingLevel = 0;
		while (
			currentNode &&
			(offsetTillRangeStart == null || offsetTillRangeEnd == null)
		) {
			let indent = "";
			for (let i = 0; i < currentNestingLevel; i++) {
				indent += "  ";
			}
			// pp.log(`${indent}at node -- node, type, name`, currentNode, currentNode.nodeType, currentNode.nodeName);

			if (currentNode.nodeType == 3 || !currentNode.childNodes.length) {
				// pp.log(`${indent}at text or singleton node`, currentNode, currentNode.nodeType, currentNode.nodeName, offsetTillNow);
				let lengthToSlice;
				let leadingLineBreaksCount = 0;
				if (currentNode.nodeType == 3) {
					const textContent = pp.tinyMCE.sanitizeTextContent(
						currentNode.textContent,
					);
					leadingLineBreaksCount = normalizedContent.indexOf(textContent);
					lengthToSlice = leadingLineBreaksCount + textContent.length;
				} else {
					// pp.log(`${indent}- not nodeType 3`);
					leadingLineBreaksCount = 1;
					lengthToSlice = 1; // Assume that the node has no content, but corresponds to one line break in the normalizedContent
				}
				// pp.log(`${indent}- leadingLineBreaksCount`, leadingLineBreaksCount);

				normalizedContent = normalizedContent.slice(lengthToSlice);

				if (currentRange.startContainer == currentNode) {
					// pp.log(`${indent}- found start at:`, offsetTillNow + currentRange.startOffset + leadingLineBreaksCount);
					offsetTillRangeStart =
						offsetTillNow + currentRange.startOffset + leadingLineBreaksCount;
				}
				if (currentRange.endContainer == currentNode) {
					// pp.log(`${indent}- found end at:`, offsetTillNow + currentRange.endOffset + leadingLineBreaksCount);
					offsetTillRangeEnd =
						offsetTillNow + currentRange.endOffset + leadingLineBreaksCount;
				}
				offsetTillNow += lengthToSlice;

				if (currentNode.nextSibling) {
					currentNode = currentNode.nextSibling;
				} else {
					while (
						// @ts-expect-error
						!currentNode.parentNode.nextSibling &&
						// @ts-expect-error
						currentNode.parentNode.nodeName != "BODY"
					) {
						// @ts-expect-error
						currentNode = currentNode.parentNode;
						currentNestingLevel -= 1;
						// pp.log(`${indent}- traversing back up to`, currentNode);
					}
					// pp.log(`${indent}- reached`, currentNode);
					// @ts-expect-error
					currentNode = currentNode.parentNode.nextSibling;
					currentNestingLevel -= 1;
				}
			} else if (currentNode.childNodes.length) {
				currentNode = currentNode.firstChild;
				currentNestingLevel += 1;
			}
		}
		// Guard clause
		// @ts-expect-error
		if (offsetTillRangeStart > editor.normalizedContent.length) {
			// @ts-expect-error
			offsetTillRangeStart = editor.normalizedContent.length;
		}
		// @ts-expect-error
		if (offsetTillRangeEnd > editor.normalizedContent.length) {
			// @ts-expect-error
			offsetTillRangeEnd = editor.normalizedContent.length;
		}
		pp.log(
			"getSelectionRange start, end",
			offsetTillRangeStart,
			offsetTillRangeEnd,
		);
		return { start: offsetTillRangeStart, end: offsetTillRangeEnd };
	},

	getSelectionElements: (editor, startPosition, endPosition = undefined) => {
		let returnProps = {
			startNode: null,
			startNodeOffset: null,
			endNode: null,
			endNodeOffset: null,
		};

		pp.log(
			"getSelectionElements editor, startPosition, endPosition",
			editor.container,
			startPosition,
			endPosition,
		);

		let normalizedContent = editor.normalizedContent;
		// pp.log("normalized content at start", normalizedContent);

		// Guard clause
		if (!normalizedContent.length) {
			returnProps.startNode = returnProps.endNode =
				editor.getBody().firstChild.firstChild || editor.getBody().firstChild;
			// @ts-expect-error
			returnProps.startNodeOffset = returnProps.endNodeOffset = 0;
			return returnProps;
		}

		let offsetTillNow = 0;
		let currentNode = editor.getBody().firstChild;
		let currentNestingLevel = 0;
		// START while loop
		while (
			currentNode &&
			(returnProps.startNode === null || returnProps.endNode === null)
		) {
			let logIndent = "  ".repeat(currentNestingLevel);
			// pp.log(`${logIndent}at node with current offset: ${offsetTillNow}`, currentNode, currentNode.nodeType, currentNode.nodeName);

			if (currentNode.nodeType == 3 || !currentNode.childNodes.length) {
				// pp.log(`${logIndent}at node with current offset: ${offsetTillNow}`, currentNode, currentNode.nodeType, currentNode.nodeName);
				let leadingLineBreaksCount;
				let trailingLineBreaksCount = 0;
				let lengthToSlice;
				// pp.log(`${logIndent}- normalizedContent right now: "${normalizedContent}"`);
				const sanitizedNodeContent = pp.tinyMCE.sanitizeTextContent(
					currentNode.textContent,
				);
				leadingLineBreaksCount =
					normalizedContent.indexOf(sanitizedNodeContent);
				// pp.log(`${logIndent}- sanitizedNodeContent:`, sanitizedNodeContent);
				if (
					normalizedContent.indexOf(
						`${leadingLineBreaksCount != -1 ? "\n".repeat(leadingLineBreaksCount) : ""}${sanitizedNodeContent}\n`,
					) == 0
				) {
					// pp.log(`${logIndent}- adding trailing`);
					trailingLineBreaksCount = 1;
				}
				let lastSingleParentNode = currentNode;
				while (
					lastSingleParentNode.parentNode.childNodes.length == 1 &&
					lastSingleParentNode.parentNode.nodeName != "BODY"
				) {
					lastSingleParentNode = lastSingleParentNode.parentNode;
				}
				lengthToSlice =
					leadingLineBreaksCount +
					trailingLineBreaksCount +
					sanitizedNodeContent.length;
				// pp.log(`${logIndent}- lastSingleParentNode, leadingLineBreaksCount, trailingLineBreaksCount`, lastSingleParentNode, leadingLineBreaksCount, trailingLineBreaksCount);

				// Test if arrived at start node -----------------------
				if (
					!returnProps.startNode &&
					offsetTillNow +
						leadingLineBreaksCount +
						sanitizedNodeContent.length >=
						startPosition
				) {
					let startNodeOffset = startPosition - offsetTillNow;
					// pp.log(`${logIndent}- ARRIVED at startPosition with offset in node`, startNodeOffset);
					// @ts-expect-error
					returnProps.startNodeOffset = startNodeOffset;
					// If the selection starts at offset 0:
					// E.g. in
					// <p>  <- lastSingleParentNode
					//   <u>
					//     textNode "foo bar"  <- currentNode
					// we want the `<p>` to be the start node.
					// In e.g.
					// <p>  <- lastSingleParentNode
					//   <u>
					//     textNode "foo bar"
					//   <i>
					//     textNode "jo dawg" <- currentNode
					// we want the `<i>` to be the start node.
					returnProps.startNode =
						startNodeOffset == 0 ? lastSingleParentNode : currentNode;
					if (!returnProps.endNode && endPosition === undefined) {
						returnProps.endNode = currentNode;
						// @ts-expect-error
						returnProps.endNodeOffset = startNodeOffset;
						// pp.log(`${logIndent}- ARRIVED at endPosition for 'undefined' end, returning`, returnProps);
					}
				}

				// Test if arrived at end node -----------------------
				if (
					offsetTillNow +
						leadingLineBreaksCount +
						sanitizedNodeContent.length >=
					// @ts-expect-error
					endPosition
				) {
					// @ts-expect-error
					let endNodeOffset = endPosition - offsetTillNow;
					// pp.log(`${logIndent}- ARRIVED at endPosition with offset in node`, endNodeOffset);
					returnProps.endNode = currentNode;
					// @ts-expect-error
					returnProps.endNodeOffset = endNodeOffset;
				} else if (
					offsetTillNow +
						leadingLineBreaksCount +
						sanitizedNodeContent.length +
						trailingLineBreaksCount ==
					endPosition
				) {
					const endNodeOffset =
						// @ts-expect-error
						endPosition - offsetTillNow - sanitizedNodeContent.length;
					// pp.log(`${logIndent}- ARRIVED at endPosition for trailing line breaks in node`, endNodeOffset);
					returnProps.endNode = lastSingleParentNode;
					// @ts-expect-error
					returnProps.endNodeOffset = 1;
				}

				// pp.log(`${logIndent}- slicing length: ${lengthToSlice}, content: "${normalizedContent.substr(0, lengthToSlice)}"`);
				normalizedContent = normalizedContent.slice(lengthToSlice);
				offsetTillNow += lengthToSlice;

				// Go to next eligible node -----------------------
				if (currentNode.nextSibling) {
					currentNode = currentNode.nextSibling;
				} else {
					while (
						!currentNode.parentNode.nextSibling &&
						currentNode.parentNode.nodeName != "BODY"
					) {
						currentNode = currentNode.parentNode;
						currentNestingLevel -= 1;
						logIndent = logIndent.slice(2);
						// pp.log(`${logIndent}- traversed back up to`, currentNode);
					}
					// After *one* trailing line break (trailingLineBreaksCount) has been cut, test if there is still another trailing line break *and*
					// both the current node and its parent are DOM nodes (`nodeType` 1), in which case we want to cut the 2nd trailing line break right now.
					// This is the case in e.g.
					//    <ul>  <- currentNode.parentNode
					//       <li>  <- currentNode
					// if (currentNode.nodeType == 1 && ['UL', 'OL', 'LI'].includes(currentNode.parentNode.nodeName) && normalizedContent.startsWith("\n")) { more explicit version with testing for nodeName
					if (
						normalizedContent.startsWith("\n") &&
						currentNode.nodeType == 1 &&
						currentNode.parentNode.nodeType == 1 &&
						currentNode.nodeName != "BR"
					) {
						// pp.log(`${logIndent}- got closing parent node`, currentNode);
						normalizedContent = normalizedContent.slice(1);
						offsetTillNow += 1;
					}
					currentNode = currentNode.parentNode.nextSibling;
					logIndent = logIndent.slice(2);
					// pp.log(`${logIndent}- reached next sibling up`, currentNode ? currentNode.previousSibling : "(no node, no prev sibling)", currentNode);
					currentNestingLevel -= 1;
				}
			} else if (currentNode.childNodes.length) {
				logIndent += "  ";
				currentNestingLevel += 1;
				currentNode = currentNode.firstChild;
				// pp.log(`${logIndent}- went to childNode`, currentNode);
			}
		}
		// END while loop

		if (!returnProps.endNode) {
			// pp.log("reached text and without endNode", editor.getBody().lastChild);
			const lastTextNode = editor.getBody().lastChild.lastChild;
			const sanitizedNodeContent = pp.tinyMCE.sanitizeTextContent(
				lastTextNode.textContent,
			);
			const length =
				sanitizedNodeContent.length -
				pp.tinyMCE.countHighSurrogates(sanitizedNodeContent);
			returnProps.endNode = lastTextNode;
			// @ts-expect-error
			returnProps.endNodeOffset = length;
		}
		pp.log("returning", returnProps);
		return returnProps;
	},

	isNodeFirstAnchestorOf: (potentialAnchestor, node) => {
		let traversingNode = node;
		while (traversingNode != potentialAnchestor) {
			// pp.log(`- recur`, traversingNode);
			if (traversingNode != traversingNode.parentNode.firstChild) {
				return false;
			}
			// Else
			traversingNode = traversingNode.parentNode;
		}
		return true;
	},

	setSelectionRange: (editor, selectionStart, selectionEnd = undefined) => {
		pp.log(
			"setSelectionRange -- selectionStart, selectionEnd",
			selectionStart,
			selectionEnd,
		);
		const selectionProps = pp.tinyMCE.getSelectionElements(
			editor,
			selectionStart,
			selectionEnd,
		);
		pp.log("- got props", selectionProps);

		// Guard clause
		if (
			!selectionProps.startNode ||
			(selectionEnd !== undefined && !selectionProps.endNode)
		) {
			pp.log(
				"- got invalid props from `getSelectionElements`:",
				selectionProps,
			);
			return;
		}
		const newRange = editor.selection.dom.createRng();
		newRange.setStart(selectionProps.startNode, selectionProps.startNodeOffset);
		if (selectionEnd !== undefined) {
			newRange.setEnd(selectionProps.endNode, selectionProps.endNodeOffset);
		}

		const sel = editor.selection.getSel();
		// pp.log("sel", sel);
		if (sel) {
			sel.removeAllRanges();
			sel.addRange(newRange);
			return sel;
		} else {
			pp.log("- setSelectionRange did not get a selection");
		}
		return null;
	},

	showDiffBetweenEditors: (diffArr, editor, prevVersionEditor) => {
		pp.log(
			"###### showDiffBetweenEditors #####",
			diffArr,
			editor.container,
			prevVersionEditor.container,
		);

		let offset = 0;
		let prevOffset = 0;
		// let tick = 0;
		const changes = [];

		$(diffArr).each(function () {
			const el = this;
			// tick += 1;
			// setTimeout(function() {
			const changeType = el[0];
			const changeText = el[1].replace("\\n", "\n"); // `diff_main´ escapes line breaks, so unescape them again
			// pp.log(`\n\n####### at change ${changeType}, changeText: "${changeText}"`);

			switch (changeType) {
				case 0: // no changes
					offset += changeText.length;
					prevOffset += changeText.length;

					// $(prevVersionEditor.getBody().parentElement).children('.j-virtual-cursor').remove();
					// $(editor.getBody().parentElement).children('.j-virtual-cursor').remove();
					// pp.tinyMCE.highlightEditorText(prevVersionEditor, {selectionStart: prevOffset, selectionColor: 'black', class: 'j-virtual-cursor'}); // `selectionEnd` is not needed here
					// pp.tinyMCE.highlightEditorText(editor, {selectionStart: offset, selectionColor: 'black', class: 'j-virtual-cursor'}); // `selectionEnd` is not needed here
					break;

				case 1: // insertion
					const inserted = pp.tinyMCE.getSelectionElements(
						editor,
						offset,
						offset + changeText.length,
					);
					// pp.log("at inserted", inserted);
					// pp.tinyMCE.highlightEditorText(editor, {selectionStart: offset, selectionEnd: offset + changeText.length, selectionColor: 'green'});

					changes.push({
						type: "insert",
						start: offset,
						end: offset + changeText.length,
					});
					offset += changeText.length;
					break;

				case -1: // deletion
					let contentToInsert = "";
					let oldNormalizedContent = editor.normalizedContent;
					const deletedProps = pp.tinyMCE.getSelectionElements(
						prevVersionEditor,
						prevOffset,
						prevOffset + changeText.length,
					);
					pp.tinyMCE.setSelectionRange(editor, offset); // Set new editor's cursor to our current position
					// pp.log("got deleted props from `getSelectionElements`", deletedProps);
					if (
						// @ts-expect-error
						deletedProps.startNode.nodeType == 1 &&
						deletedProps.startNode == deletedProps.endNode
					) {
						// A DOM element, NOT a text node
						// @ts-expect-error
						contentToInsert = deletedProps.startNode.outerHTML;
					}
					// In e.g.
					// <p>  <- selectionProps.endNode with endNodeOffset 1, i.e. the very end of the DOM element with `nodeType` 3
					//   <u>
					//     textNode "foo bar"  <- selectionProps.startNode
					// - this means that the last character in `changeText` corresponds to a line break (or new paragraph), in which case `getSelectionElements`
					// returns the up-most parent of `startNode` as the `endNode`.
					// -> Close the current node and start a new one
					else if (
						// @ts-expect-error
						deletedProps.startNode.nodeType == 3 &&
						// @ts-expect-error
						deletedProps.startNode.textContent.length ==
							deletedProps.startNodeOffset &&
						deletedProps.endNodeOffset == 1 &&
						pp.tinyMCE.isNodeFirstAnchestorOf(
							deletedProps.endNode,
							deletedProps.startNode,
						) &&
						// @ts-expect-error
						deletedProps.endNode.nextSibling
					) {
						// pp.log("special case for `contentToInsert`");
						// @ts-expect-error
						contentToInsert = `</${deletedProps.endNode.nodeName}><${deletedProps.endNode.nextSibling.nodeName}>`;
					} else {
						const deletedSelection =
							prevVersionEditor.selection.dom.createRng();
						deletedSelection.setStart(
							deletedProps.startNode,
							deletedProps.startNodeOffset,
						);
						deletedSelection.setEnd(
							deletedProps.endNode,
							deletedProps.endNodeOffset,
						);
						const clonedRange = deletedSelection.cloneContents().children;
						const clonedNodes = deletedSelection.cloneContents().childNodes;
						// pp.log("- at deleted range -- clonedNodes, clonedRange", clonedNodes, clonedRange);
						for (let i = 0; i < clonedNodes.length; i++) {
							const node = clonedNodes[i];
							if (i == 0 && deletedSelection.startOffset != 0) {
								// First node and the selection doesn't begin at the node's first character
								contentToInsert += node.textContent;
							} else if (i < clonedNodes.length - 1) {
								// Not the last node, so clone the full outerHTML (if present)
								contentToInsert += node.outerHTML;
							} else {
								contentToInsert +=
									clonedNodes[i].outerHTML || clonedNodes[i].textContent;
							}
						}
					}

					// pp.log(`inserting "${contentToInsert}"`);
					editor.insertContent(contentToInsert);
					// pp.log("HTML content now", editor.getContent());
					pp.tinyMCE.normalizeAndSaveContent(editor); // Needs to be updated now
					// Can't use `changeText.length` because more extra content might be added in above "special case"
					const effectiveSizeOfInsertedText =
						editor.normalizedContent.length - oldNormalizedContent.length;
					// pp.log("effectively added chars", effectiveSizeOfInsertedText);
					// pp.tinyMCE.highlightEditorText(editor, {selectionStart: offset, selectionEnd: offset + effectiveSizeOfInsertedText, selectionColor: 'red'});

					changes.push({
						type: "delete",
						start: offset,
						end: offset + changeText.length,
					});
					offset += effectiveSizeOfInsertedText;
					prevOffset += changeText.length;
					break;
			}
			// }, tick * 2000)
		});
		pp.log("changes", changes);
		// setTimeout(() => {
		// 	$(prevVersionEditor.getBody().parentElement).children('.j-virtual-cursor').remove();
		// 	$(editor.getBody().parentElement).children('.j-virtual-cursor').remove();
		// }, (diffArr.length + 1) * 2000)
		setTimeout(
			() => {
				changes.forEach((changeData, index) => {
					pp.log("-------- change", index, changeData);
					const paintingFunctionWrapper = (editor, editorRect, rectIndex) => {
						pp.tinyMCE[
							changeData.type == "insert"
								? "highlightInsertedText"
								: "highlightDeletedText"
						](editor, editorRect);
					};

					pp.tinyMCE.highlightEditorText(
						editor,
						changeData.start,
						changeData.end,
						paintingFunctionWrapper,
					);
				});
			},
			bowser.chrome || bowser.safari ? 300 : 0,
		);
		pp.log("###### END showDiffBetweenEditors #####");
	},

	highlightEditorText: (
		editor,
		selectionStart,
		selectionEnd,
		paintingFunction,
	) => {
		pp.log(
			"highlightEditorText data",
			selectionStart,
			selectionEnd,
			paintingFunction,
		);

		const newRange = editor.selection.dom.createRng();

		// Guard clause: For when the caret is at 0, the loop below will not be entered
		if (selectionStart == 0 && selectionEnd == 0) {
			// Try to get the first child node (= a text node) if present
			const firstTextNode = editor.getBody().firstChild;
			newRange.setStart(firstTextNode.firstChild || firstTextNode, 0);
			newRange.setEnd(firstTextNode.firstChild || firstTextNode, 0);
		} else {
			const selectionProps = pp.tinyMCE.getSelectionElements(
				editor,
				selectionStart,
				selectionEnd,
			);
			// In e.g.
			// <p>  <- selectionProps.startNode
			//   <u>
			//     textNode "foo bar"  <- selectionProps.endNode
			// - set the startNode to be the endNode
			if (
				pp.tinyMCE.isNodeFirstAnchestorOf(
					selectionProps.startNode,
					selectionProps.endNode,
				)
			) {
				selectionProps.startNode = selectionProps.endNode;
			}

			// In e.g.
			// <p>  <- selectionProps.endNode with endNodeOffset 1, i.e. the very end of the DOM element with `nodeType` 3
			//   <u>
			//     textNode "foo bar"  <- selectionProps.startNode
			// - this means that there is a line break (or new paragraph), at the end of the selection, in which case `getSelectionElements`
			// returns the up-most parent of `startNode` as the `endNode`.
			// -> Mark the *next* sibling instead
			else if (
				selectionProps.endNodeOffset == 1 &&
				// @ts-expect-error
				selectionProps.endNode.parentNode.nodeName == "BODY" &&
				pp.tinyMCE.isNodeFirstAnchestorOf(
					selectionProps.endNode,
					selectionProps.startNode,
				)
			) {
				selectionProps.startNode = selectionProps.endNode =
					// @ts-expect-error
					selectionProps.endNode.nextSibling.firstChild;
				// @ts-expect-error
				selectionProps.startNodeOffset = selectionProps.endNodeOffset = 0;
			}
			newRange.setStart(
				selectionProps.startNode,
				selectionProps.startNodeOffset,
			);
			newRange.setEnd(selectionProps.endNode, selectionProps.endNodeOffset);
		}

		pp.log("highlightEditorText range:", newRange, newRange.toString());
		let clientRects = newRange.getClientRects();
		// This will be the case for empty singleton elements like `<br>`. Use the node's parent to display the caret position
		if (!clientRects.length && newRange.startContainer.parentNode !== null) {
			pp.log("getting top-most client rects");
			clientRects = newRange.startContainer.parentNode.getClientRects();
		}
		for (let index = 0; index < clientRects.length; index++) {
			paintingFunction(editor, clientRects[index], index);
		}
	},

	initCharsUtilIntegration: (editor) => {
		// @ts-expect-error
		new CharsUtil(editor, {
			maxCount: editor.targetElm.maxLength,
			dialTargetSelector: "input.j-char-count-dial",
			$containerEl: $(editor.targetElm).closest("form"),
			$popoverEl: $(editor.container),
			getPlainContentMethod: () => {
				// Make a paragraph into a simple line break and trim leading and trailing whitespace
				return editor
					.getContent({ format: "text" })
					.replace("\n\n", "\n")
					.trim();
			},
			inputEventSetup: (charsUtilInstance) => {
				editor.on("input paste", (event) => {
					if (
						editor.getContent({ format: "text" }).length <=
						charsUtilInstance.maxCount
					) {
						// Only update text cout
						charsUtilInstance._updateTextCount();
						return;
					}
					editor.undoManager.undo();
					const editorTargetData = $(editor.targetElm).data();
					let targetPad;
					// Always use the pad from the target's data attribute, not the one from the params.
					// It might have been removed in the meantim (from `clearData`), in which case we don't want to call `notifyTinyMCENodeChange` anymore
					if (Object.keys(editorTargetData).includes("padSlaveFor")) {
						targetPad = $(editorTargetData.padSlaveFor).data("pad");
					} else {
						targetPad = editorTargetData.pad;
					}
					// There is no way to *not* propagate the event to other listeners
					// (`.preventDefault()`, `.stopPropagation()` and `return false` don't work),
					// so let the Pad (which listens to 'input') run an empty `updateFayeTimeout` once so that it
					// won't call `_checkStatesForFaye`.
					if (targetPad.updateFayeTimeout) {
						clearTimeout(targetPad.updateFayeTimeout);
						targetPad.updateFayeTimeout = setTimeout(() => {
							targetPad.updateFayeTimeout = null;
						}, 50);
					}
					if (event.type == "paste") {
						charsUtilInstance._handleTrimmedPaste();
					}
				});

				// NB 'change' is being fired when the content is changed from the outside (via PrivatePub)
				$(editor.targetElm).on("input change", (event) => {
					charsUtilInstance._updateTextCount();
				});
				// Show remaining chars right after view is loaded
				$(editor.targetElm).trigger("input");
			},
		});
	},

	sanitizeTextContent: (textContent) => {
		return textContent
			.replace(/\ufeff/g, "")
			.replace(/\u00ad/g, "")
			.replace(/&#65279;/g, "")
			.replace(/&#173;/g, "")
			.replace(/&shy;/g, "");
	},

	countHighSurrogates: (text) => {
		return (text.match(/[\uD800-\uDBFF]/g) || []).length;
	},

	highlightUserSelection: (
		editor,
		editorRect,
		rectIndex,
		editingEntityId,
		editingEntityColor,
	) => {
		pp.log(
			"into highlightUserSelection -- editorRect, rectIndex",
			editorRect,
			rectIndex,
		);
		const $mceHtmlContainr = editor.getBody().parentElement;
		// Show at least 3px width (for when the selection's start and end is identical).
		// Collapse the selection (visually ofc) to the same width if it would span the full width of the editor window.
		let widthToDisplay;
		if (
			// @ts-expect-error
			$(editor.getBody()).width() - 1 <= editorRect.width ||
			editorRect.width < 2
		) {
			widthToDisplay = 3;
		} else {
			widthToDisplay = editorRect.width;
		}
		const topOffset = editorRect.y + editor.getBody().parentElement.scrollTop;
		let overlay = editor.getDoc().createElement("span");
		overlay.className = "j-user-selection";
		overlay.style.backgroundColor = editingEntityColor;
		overlay.style.opacity = "66%";
		overlay.style.position = "absolute";
		overlay.style.width = widthToDisplay + "px";
		overlay.style.height = editorRect.height + "px";
		overlay.style.top = topOffset + "px";
		overlay.style.left = editorRect.x + "px";
		overlay.style.zIndex = "-1";
		$mceHtmlContainr.prepend(overlay);
		if (editingEntityId !== undefined && rectIndex == 0) {
			let overlayText = editor.getDoc().createElement("span");
			overlayText.className = "j-user-selection";
			overlayText.style.opacity = "100%";
			overlayText.style.backgroundColor = editingEntityColor;
			overlayText.style.color = "white";
			overlayText.style.fontSize = "10px";
			overlayText.style.height = "14px";
			overlayText.textContent = pp.currentActorId
				? VueStore.getters.actorData(editingEntityId).names[I18n.locale]
				: `${I18n.t("activerecord.models.user.one")} #${editingEntityId}`;
			overlayText.style.position = "absolute";
			overlayText.style.left = editorRect.x + "px";
			overlayText.style.top = `${topOffset - 14}px`;
			overlayText.style.userSelect = "none";
			overlayText.style.whiteSpace = "nowrap";
			overlay.after(overlayText);
		}
	},

	highlightInsertedText: (editor, editorRect) => {
		// pp.log("at rect", rect, $(editor.getBody()).width());
		const $mceHtmlContainr = editor.getBody().parentElement;
		// Show at least 3px width (for when the selection's start and end is identical).
		// Collapse the selection (visually ofc) to the same width if it would span the full width of the editor window.
		let widthToDisplay;
		let overlay = editor.getDoc().createElement("span");
		if (
			// @ts-expect-error
			$(editor.getBody()).width() - 1 <= editorRect.width ||
			editorRect.width < 2
		) {
			widthToDisplay = 3;
		} else {
			widthToDisplay = editorRect.width;
		}
		overlay.style.backgroundColor = pp.viewHelpers.detectCssRuleFor(
			".Draft__text-block ins",
			"background",
		);
		overlay.style.opacity = "60%";
		overlay.style.position = "absolute";
		overlay.style.width = widthToDisplay + "px";
		overlay.style.height = editorRect.height + "px";
		overlay.style.top =
			editorRect.y + editor.getBody().parentElement.scrollTop + "px";
		overlay.style.left = editorRect.x + "px";
		overlay.style.zIndex = "-1";
		$mceHtmlContainr.prepend(overlay);
	},

	highlightDeletedText: (editor, editorRect) => {
		// pp.log("at rect", rect, $(editor.getBody()).width());
		const $mceHtmlContainr = editor.getBody().parentElement;
		// Show at least 3px width (for when the selection's start and end is identical).
		// Collapse the selection (visually ofc) to the same width if it would span the full width of the editor window.
		let widthToDisplay;
		if (
			// @ts-expect-error
			$(editor.getBody()).width() - 1 <= editorRect.width ||
			editorRect.width < 2
		) {
			widthToDisplay = 3;
		} else {
			widthToDisplay = editorRect.width;
		}

		// The red background
		let overlay = editor.getDoc().createElement("span");
		overlay.style.backgroundColor = pp.viewHelpers.detectCssRuleFor(
			".Draft__text-block del",
			"background",
		);
		overlay.style.opacity = "60%";
		overlay.style.position = "absolute";
		overlay.style.width = widthToDisplay + "px";
		overlay.style.height = editorRect.height + "px";
		overlay.style.top =
			editorRect.y + editor.getBody().parentElement.scrollTop + "px";
		overlay.style.left = editorRect.x + "px";
		overlay.style.zIndex = "-1";

		// The strike-through
		let strikeThrough = editor.getDoc().createElement("span");
		strikeThrough.style.backgroundColor = pp.viewHelpers.detectCssRuleFor(
			"h1",
			"color",
		);
		strikeThrough.style.opacity = "60%";
		strikeThrough.style.position = "absolute";
		strikeThrough.style.width = widthToDisplay + "px";
		strikeThrough.style.height = "1px";
		strikeThrough.style.top =
			editorRect.y +
			editorRect.height / 2 +
			editor.getBody().parentElement.scrollTop +
			"px";
		strikeThrough.style.left = editorRect.x + "px";
		strikeThrough.style.zIndex = "-1";
		$mceHtmlContainr.prepend(overlay);
		$mceHtmlContainr.prepend(strikeThrough);
	},
};
